<div class="wccard p-3 mb-1 ml--15" style="background-color: #FFFEE5;" *ngIf="!isProjectDetailsEvaluationCriteriaTab">
  <div class="row">
    <div class="col">
      <div class="d-flex align-items-center justify-content-between">
        <span class="f-18 font-weight-500" style="color: #484B59;">Enter Autopilot<sup><span>AI</span></sup> Evaluation
          Criteria</span>

        <div class="p-1">
          <span class="f-14 font-weight-400" style="color: #969696;">
            <i class="fa-regular fa-lightbulb-on"></i>
            <span class="ml-1">Want help - </span>
            <span class="text-webbtree-green pointer" (click)="learnMoreDetails()">
              Learn More
              <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mr-0">
  <div class="col wccard pt-3">
    <!-- Evaluation Header -->
    <div class="row" *ngIf="!isProjectDetailsEvaluationCriteriaTab">
      <div class="col mb-3">
        <!-- <p class="f-18 font-weight-500 mb-2" style="color: #484B59;">Enter AI evaluation criteria</p> -->
        <p class="f-12 font-weight-400 mb-0" style="color: #484B59;">
          Suggested Autopilot<sup style="top: -1px!important;"><span>AI</span></sup> criteria based on your job
          description. Click to select and add, or create your own
        </p>
      </div>
    </div>

    <!-- Evaluation Sub Header for project details tab -->
    <div class="row" *ngIf="isProjectDetailsEvaluationCriteriaTab">
      <div class="col mb-3">
        <div class="d-flex justify-content-between align-items-center" *ngIf="projectDetails?.talenttotalstrength > 0">
          <div>
            <p class="f-14 font-weight-600" style="color: #484B59;">Autopilot<sup
                style="top: -1px!important;"><span>AI</span></sup> Criteria</p>
            <p class="f-14 font-weight-400">Move items up or down to update the order and importance of
              criteria.</p>
          </div>
          <div class="text-webbtree-green pointer" *ngIf="!editMode" (click)="enableEditMode('edit')"
            style="border: 1px solid #2E93A1; padding: 4px 21px 4px 7px;">
            <i class="fa-regular fa-pen-to-square"></i>
            <span class="ml-1">Edit Criteria</span>
          </div>

          <div class="text-webbtree-green pointer" *ngIf="editMode" (click)="enableEditMode('close')"
            style="border: 1px solid #2E93A1; padding: 4px 11px 4px 10px;">
            <i class="fa-regular fa-xmark"></i>
            <span class="ml-1">Close</span>
          </div>

        </div>
      </div>
    </div>


    <div class="row">
      <div class="col">
        <div style="border: 1px solid #D5DEE6; padding: 10px;" *ngIf="!showSkeletonLoader">
          <!-- Top Priority -->
          <div *ngIf="formLength().length > 1" class="mb-2">
            <span class="gradient-text">
              <i class="fa-regular fa-angle-up"></i> (High Priority)
            </span>
          </div>

          <!-- Evaluation Criteria Form -->
          <div [formGroup]="aiScreeningMasterForm">
            <div cdkDropList [cdkDropListDisabled]="!editMode && isProjectDetailsEvaluationCriteriaTab"
              (cdkDropListDropped)="onDrop($event)" class="d-flex flex-column gap-3">

              <div *ngFor="let key of formLength(); let idx = index" [formGroupName]="key" cdkDrag
                [cdkDragDisabled]="!editMode && isProjectDetailsEvaluationCriteriaTab" class="criteria-drag-container">

                <div
                  *ngIf="!isProjectDetailsEvaluationCriteriaTab || (editMode && isProjectDetailsEvaluationCriteriaTab)">
                  <span class="mr-2 cursor-move">
                    <i class="fa-solid fa-grip-vertical f-20 text-9696"></i>
                  </span>
                </div>

                <div class="ai-criteria-card">
                  <div class="d-flex justify-content-between mb-3">
                    <div class="w-75 d-flex align-items-center">
                      <p class="text-truncate mb-0 font-weight-500">Criteria {{ idx + 1 }}</p>
                    </div>


                    <div class="text-right pointer"
                      *ngIf="(editMode || !isProjectDetailsEvaluationCriteriaTab) && formLength().length > 1">
                      <span (click)="deleteCriteria(key)">
                        <i class="far fa-trash f-14" style="color: #EC221F;"></i>
                      </span>
                    </div>
                  </div>

                  <div>
                    <span *ngIf="!editMode && isProjectDetailsEvaluationCriteriaTab">
                      {{ aiScreeningMasterForm.get([key, 'question'])?.value | titlecase}}
                    </span>

                    <input data-testid="auto-app-evaluation-criteria-input-1" *ngIf="editMode || !isProjectDetailsEvaluationCriteriaTab" formControlName="question"
                      type="text" class="wc-form-control" placeholder="Enter Autopilotᴬᴵ Evaluation Criteria" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Low Priority -->
          <div *ngIf="formLength().length > 1" class="mb-2">
            <span class="gradient-text">
              <i class="fa-regular fa-angle-down"></i>(Low Priority)
            </span>
          </div>

          <!-- Evaluation Criteria AI Suggession -->
          <div class="ai-chip-container"
            *ngIf="formLength().length < 5 && ((!isProjectDetailsEvaluationCriteriaTab) || (isProjectDetailsEvaluationCriteriaTab && editMode))">
            <span *ngFor="let c of SUGGESTED_CRITERIA | slice:0:5">
              <ng-container *ngIf="!c.selected">
                <p class="ai-screening-chips" (click)="useGivenCriteria(c)">
                  <i class="fa-solid fa-plus mr-2"></i>
                  <span>{{c.suggestion_content}}</span>
                </p>
              </ng-container>
            </span>
          </div>

        </div>

        <div class="skeleton-wrapper" *ngIf="showSkeletonLoader">
          <div class="skeleton-row header wccard p-3">
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
          </div>
        </div>

        <!-- Add More Evaluation Criteria -->
        <div
          *ngIf="(formLength().length < 5 && !isProjectDetailsEvaluationCriteriaTab) || (formLength().length < 5 && isProjectDetailsEvaluationCriteriaTab && editMode)"
          class="text-center mb-3" (click)="addNewCriteria()">
          <button data-testid="auto-app-evaluation-criteria-button-1" class="btn-trms-small mt-6 criteria-btn" [disabled]="showAddCriteriaSpinner">
            <span [ngClass]="{ 'spinner-border text-white spinner-size': showAddCriteriaSpinner }"
              [ngStyle]="{ 'width: 20px; height: 20px;': showAddCriteriaSpinner }">
              {{showAddCriteriaSpinner ? '' : '+ Add More Criteria'}}
            </span>
          </button>
        </div>

        <!-- Save Evaluation Criteria -->
        <div class="text-right mt-6"
          *ngIf="(isProjectDetailsEvaluationCriteriaTab && editMode) || !isProjectDetailsEvaluationCriteriaTab">
          <button data-testid="auto-app-evaluation-criteria-button-2" class="btn-trms-medium mb-6"
            (click)="isProjectDetailsEvaluationCriteriaTab ? openEditEvaluationCriteriaModel() : submitChanges()"
            [disabled]="showExploreCandidateSpinner">
            <span [ngClass]="{ 'spinner-border text-white spinner-size': showExploreCandidateSpinner }"
              [ngStyle]="{ 'width: 20px; height: 20px;': showExploreCandidateSpinner }">
              {{showExploreCandidateSpinner ? '' : isProjectDetailsEvaluationCriteriaTab ? 'Save Changes' : 'Explore Candidates'}}
            </span>
          </button>
        </div>

      </div>
    </div>
  </div>
</div>


<!-- For Open Edit Evaluation model -->
<ng-template #editEvaluationCriteria class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-600">Autopilot<sup><span>AI</span></sup> Criteria Updated</span>
      <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <div class="d-flex flex-column w-100 mt-2">
      <span class="f-14">Webbtree Autopilot<sup><span>AI</span></sup> will update your "To Review" list with fresh
        results based on your changes.
        Proceed?</span>
    </div>

    <div class="row mt-2">
      <div class="col text-right">
        <button data-testid="auto-app-evaluation-criteria-button-3" class="btn-trms-white mr-3" (click)="dismiss()">Cancel</button>

        <button data-testid="auto-app-evaluation-criteria-button-4" class="btn-trms-small mr-3" [ngClass]="{ 'text-center': showExploreCandidateSpinner }"
          (click)="submitChanges()" [disabled]="showExploreCandidateSpinner">
          <span [ngClass]="{ 'spinner-border spinner-size': showExploreCandidateSpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showExploreCandidateSpinner }">
            {{showExploreCandidateSpinner ? '' : 'Start Sourcing'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg" [innerHtml]="successMessage"></span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg" [innerHtml]="errorMessage"></span>
</ngb-alert>

<!-- Access management modal templates -->
<ng-template #accessManagementModal class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <span></span>
      <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <div class="text-center justify-content-between align-items-center">
            <img src="../../../assets/criteria-empty.png" alt="img-fluid" class="img-config-review mb-2">

      <p class="f-14 font-weight-600">This Job is Inactive</p>
      <p>To continue sourcing, please increasse your team’s active project slots or contact Admin to deactivate another
        active project and activate this one.</p>
      <div class="d-flex justify-content-center gap-3 mt-4">
        <button data-testid="auto-app-evaluation-criteria-button-5" class="btn-trms-small px-4" (click)="!changeButtonText && notifyAdmin()">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showNotifySpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showNotifySpinner }">
            {{showNotifySpinner ? '' : !changeButtonText ? 'Notify Admin': 'Notified'}}
          </span>
          </button>
      </div>
    </div>
  </div>
</ng-template>
